var exports = {
  "kL": "GuildModerationTab.module__container___UmxWdT",
  "uW": "GuildModerationTab.module__section___UmxWdT",
  "Gf": "GuildModerationTab.module__sectionTitle___UmxWdT",
  "yV": "GuildModerationTab.module__sectionDescription___UmxWdT",
};

module.exports = exports;
